<template>
  <div>
    <b-overlay
      :show='loading'
      rounded
      opacity='0.7'
      spinner-small
      spinner-variant='primary'
      class='w-100'
    >
      <table class="">
        <thead>
          <tr>
            <th colspan="8">Riscos Químicos</th>
          </tr>
          <tr>
            <th width="25%">Produto</th>
            <th width="25%">CAS: Agente</th>
            <th width="25%">Informações do agente</th>
            <th width="10%">ACGIH</th>
            <th width="10%">NR 15</th>
            <th width="10%">LINACH</th>
            <th width="10%">ESOCIAL - Tabela 24</th>
            <th width="10%">DECRETO 3048/99 - Anexo IV</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="8">
              <div class="legends">
                <span>Legendas: </span>
                <span>
                    <img width='18' height='14' src='../assets/images/consta.svg'  alt='Consta'/> consta
                  </span>
                <span>
                    <img width='14' height='14' src='../assets/images/naoConsta.svg'  alt='Não consta'/> não consta
                  </span>
                <span>
                    <img width='16' height='16' src='../assets/images/classificacao.svg'  alt='Em classificação'/> em classificação
                  </span>
              </div>
            </td>
          </tr>

          <template v-for="(product, indexProduct) in legalConsultationAgentsGroupedByProduct">
            <tr v-for="item in product.legalSearches" :key="`${product.product._id}_${indexProduct}_${item.legalSearchId}`">
              <template v-if="product.product._id !==  '-' ">
                <td
                  v-if='item.index < 1'
                  :rowspan="product.legalSearches.length"
                >
                  <section v-if="product.product._id !==  '-'">
                    <p class='word-break'>{{ product.product.name}}</p>
                  </section>
                </td>
              </template>

              <template v-else>
                <td>
                  <section >
                    <p class='word-break'>-</p>
                  </section>
                </td>
              </template>

              <template v-for="field in model.tableFieldsPrint">
                <td :key="`field_${field.key}`">
                  <template v-if="!model.getExist(field.key, item)">
                    <section v-if="field.key === 'informacoesAgente'">
                      <span v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'>
                        Este agente consta na NR 15 com o seguinte nome:
                            {{ item.attachment11 && item.attachment11.group
                        ? item.attachment11.group
                        : item.nameAttachment11 ? item.nameAttachment11: '-'
                        }}
                      </span>
                      <span v-else>
                        -
                      </span>
                      <br/><br/>

                      <span v-if='item.acgih && item.agent && user && user.releaseAcgih'>
                        Este agente está listado no livreto da ACGIH conforme a versão vigente no software HO Fácil Web através do nome:
                        {{ item.agent ? item.agent : '-' }}
                      </span>
                    </section>
                    <span v-else>{{model.getsearchId(field.key, item)}}</span>
                  </template>

                  <template v-else>
                    <img width='18' height='16' alt='' v-bind:src="require('../assets/images/'+model.getExist(field.key, item)+'.svg')" />
                  </template>
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </table>

      <template v-for="section in riskSections">
        <table
          v-if="section.agents && section.agents.length > 0"
          :key="section.risk"
          class="risk-table"
        >
          <thead>
            <tr>
              <th :colspan="riskTableFields.length">{{ section.title }}</th>
            </tr>
            <tr>
              <th width="25%">CAS: Agente</th>
              <th width="10%">ACGIH</th>
              <th width="10%">NR 15</th>
              <th width="10%">LINACH</th>
              <th width="10%">ESOCIAL - Tabela 24</th>
              <th width="10%">DECRETO 3048/99 - Anexo IV</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in section.agents" :key="`${section.risk}_${item.legalSearchId}`">
              <template v-for="field in riskTableFields">
                <td :key="`field_${field.key}`">
                  <template v-if="!model.getExist(field.key, item)">
                    <span>{{model.getsearchId(field.key, item)}}</span>
                  </template>

                  <template v-else>
                    <img width='18' height='16' alt='' v-bind:src="require('../assets/images/'+model.getExist(field.key, item)+'.svg')" />
                  </template>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </template>

      <template v-slot:overlay>
        <div class="text-center loading">
          <b-spinner style="width: 5rem; height: 5rem;" variant='primary' label="Large Spinner"></b-spinner>
        </div>
      </template>
    </b-overlay>
  </div>

</template>

<script>
import LegalSearchSummary from '@/models/LegalSearchSummary'
import api from '../utils/api'

export default {
  data() {
    return {
      model: LegalSearchSummary,
      selectedAgent: {},
      totalPage: 0,
      loading: false,
      legalConsultationAgentsGroupedByProduct: [],
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    summary() {
      return this.$store.getters['legalSearch/summary']
    },
    summaryMeta() {
      return this.$store.getters['legalSearch/summaryMeta']
    },
    agentsPerPage() {
      return this.$store.getters['legalSearch/agentsPerPage']
    },
    legalConsultationAgentsPhysicalRisk() {
      return this.$store.getters['legalSearch/legalConsultationAgentsPhysicalRisk']
    },
    legalConsultationAgentsBiologicalRisk() {
      return this.$store.getters['legalSearch/legalConsultationAgentsBiologicalRisk']
    },
    riskSections() {
      return [
        {
          risk: 'fisico',
          title: 'Riscos Físicos',
          agents: this.legalConsultationAgentsPhysicalRisk,
        },
        {
          risk: 'biologico',
          title: 'Riscos Biológicos',
          agents: this.legalConsultationAgentsBiologicalRisk,
        },
      ]
    },
    riskTableFields() {
      return this.model.tableFieldsPrint.filter((field) => field.key !== 'informacoesAgente')
    },
  },
  methods: {
    async load(skip) {
      const { acgih, nr15, linach, esocial, decreto, typeFilterAgents, filterForwardedAgents} = JSON.parse(localStorage.getItem('summaryMeta'))
      const orderBy = JSON.parse(localStorage.getItem('summaryMetaOrderBy'))
      const body = {
        skip,
        acgih,
        nr15,
        linach,
        esocial,
        decreto,
        orderBy,
        typeFilterAgents,
        filterForwardedAgents,
      }
      return (await api.post(`/legal-search/${this.user.id}/paged`, body)).data
    },
  },
  async mounted(){
    try {
      this.loading = true
      await this.$store.dispatch('legalSearch/load', this.user.id)
      await this.$store.dispatch('legalSearch/handleGetLoadAgentsByRisk', { userId: this.user.id })
      const { total } = this.summaryMeta
      this.totalPage = Math.ceil(total / this.agentsPerPage);
      for (let i = 1; i <= this.totalPage; i++) {
        const { legalConsultationAgentsGroupedByProduct } = await this.load(i)
        this.legalConsultationAgentsGroupedByProduct.push(...legalConsultationAgentsGroupedByProduct)
      }
      this.loading = false
      setTimeout(() => {

        window.print()
      }, 2000)
      await this.$store.dispatch('userData/updatePrintedReports', this.user.id)
    } catch (e) {
      this.loading = false
    }

  },
}
</script>

<style lang="scss" scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');

@media print {
  * {
    -webkit-print-color-adjust: exact;
  }
}

.risk-table {
  margin-top: 32px;
}

table {
  thead {
    tr {
      th {
        height: 80px;
        background-color: #022245!important;
        color: #FFFFFF;

        border: 1px solid #FFFFFF!important;

        text-align: center;

        padding: 16px;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
      }
    }
  }
  tbody {
    tr {
      td {
        height: 40px;
        color: #000;

        border: 2px solid #ddd;

        text-align: center;
        .legends {
          display: flex;
          justify-content: center;
          gap: 16px;

          margin: 8px 0;

          span:nth-child(1) {
            font-weight: 700;
          }

          span {
            display: flex;
            align-items: center;
            gap: 8px;

            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
